module.exports = __webpack_public_path__ + "img/ge.c9a85b6e.svg";